import { useFeatureToggles } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../../ProductDetail/Context/ProductDetailContext.js';

function usePrescriptionTypes() {
    const { isPrescriptionFileEnabled , featureConfigs  } = useFeatureToggles();
    const { prescriptionTypesOrder  } = useProductDetailContext();
    const allTypes = [
        'EmailPrescription',
        'ExistingCustomer',
        'NewPrescription',
        'PrescriptionFile', 
    ];
    // checking environment variables
    const envTypes = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.prescriptionTypesOrder;
    if (envTypes && envTypes.every((type)=>allTypes.includes(type)
    )) {
        return [
            ...envTypes
        ];
    }
    // checking ordered types passed in from the product-detail.tsx file
    if (prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder.length) {
        // if this item exists
        return [
            ...prescriptionTypesOrder
        ];
    }
    // default behavior
    const finalTypes = [
        'NewPrescription',
        'ExistingCustomer'
    ];
    if (isPrescriptionFileEnabled) {
        finalTypes.push('EmailPrescription');
    }
    return finalTypes;
}

export { usePrescriptionTypes };
//# sourceMappingURL=use-prescription-types.js.map
